import NovelCharactersSection from './sections/NovelCharactersSection.vue'
import NovelDramaSection from './sections/NovelDramaSection.vue'
import NovelFactsSection from './sections/NovelFactsSection.vue'
import NovelItemsSection from './sections/NovelItemsSection.vue'
import NovelLocationsSection from './sections/NovelLocationsSection.vue'
import NovelNarrativeSection from './sections/NovelNarrativeSection.vue'
import NovelOpeningSection from './sections/NovelOpeningSection.vue'
import NovelOverviewSection from './sections/NovelOverviewSection.vue'
import NovelRelationsSection from './sections/NovelRelationsSection.vue'
import { DEFAULT_SECTION_ID, SECTION_KEYS } from '@drama/novel-authoring'

const EDITORS = {
  overview: NovelOverviewSection,
  characters: NovelCharactersSection,
  locations: NovelLocationsSection,
  items: NovelItemsSection,
  facts: NovelFactsSection,
  relations: NovelRelationsSection,
  opening: NovelOpeningSection,
  narrative: NovelNarrativeSection,
  drama: NovelDramaSection,
}

/**
 * 内容分区与独立演出设置。演出设置只提供表单，继续维护人物内的预设字段，不在此暴露整个人物JSON。
 * 表单收发整本作品；`keys` 决定其余分区的 JSON 范围。音色映射仍挂在人物分区。
 */
export const NOVEL_SECTIONS = Object.freeze(
  Object.entries(SECTION_KEYS).map(([id, keys]) => ({ id, keys, editor: EDITORS[id], json_enabled: id !== 'drama' })),
)

export function novelSection(section_id) {
  return NOVEL_SECTIONS.find(section => section.id === section_id) ?? NOVEL_SECTIONS.find(section => section.id === DEFAULT_SECTION_ID)
}
export { readSection, writeSection } from '@drama/novel-authoring'
